import React from 'react';
import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';
import config from '../../constants/config';
import { DEFAULT_MAP_LOCATION } from '../../constants';

const HardwareLocation = (props) => {
    const google = props.google;
    let mapConfig = {};

    if (props.location && props.location.lat && props.location.lng) {
        const location = {
            lat: props.location.lat,
            lng: props.location.lng
        };
        mapConfig = { initialCenter: location, location };
    } else {
        mapConfig = { initialCenter: DEFAULT_MAP_LOCATION };
    }

    const image = {
        url: props.icon,
        scaledSize: new google.maps.Size(40, 40)
    };

    return (
        <Map
            google={props.google}
            style={{ width: 350, height: 350 }}
            className={'device-map'}
            zoom={7}
            mapTypeControl={false}
            streetViewControl={false}
            zoomControl={true}
            mapTypeId={'hybrid'}
            {...mapConfig}>
            {mapConfig.location && < Marker position={mapConfig.location} icon={image} />}
        </Map>
    )
}

export default GoogleApiWrapper({
    apiKey: config.common.MAP_API_KEY,
    libraries: ['roadmap', 'drawing']
})(HardwareLocation);